require('./js/script.js');